import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { ReactComponent as IconPrabhupad } from '../../assets/images/iconPrabhupad.svg';
import { ReactComponent as MenuIcon } from '../../assets/images/menu.svg';
import pageLinks from '../../utils/pageLinks';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
// import { Link } from 'react-router-dom';
import { deviceMaxWidth, deviceMinWidth } from '../../constants';
import { setShowTemporaryDrawer } from '../../store/system/actions';

// enum BTN_TYPE {
//   LINK = 'LINK',
//   BUTTON = 'BUTTON',
// }

// const menuConfig = [
//   {
//     title: 'Обновления роекта',
//     url: pageLinks.updates,
//     type: BTN_TYPE.LINK,
//   },
//   {
//     title: 'О Прабхупаде',
//     url: pageLinks.updates,
//     type: BTN_TYPE.LINK,
//   },
//   {
//     title: 'Подержите проект',
//     url: pageLinks.updates,
//     type: BTN_TYPE.BUTTON,
//   },
// ];

export default function Header() {
  // const width =
  //   window.innerWidth ||
  //   document.documentElement.clientWidth ||
  //   document.body.clientWidth;

  const styles = useStyles();
  const dispatch = useDispatch();

  const redirectToDashboard = () => {
    dispatch(push(pageLinks.home));
  };

  const showDrawer = () => {
    dispatch(setShowTemporaryDrawer(true));
  };

  return (
    <div className={styles.headerContainer}>
      <div className={styles.logoContainer}>
        <IconPrabhupad className={styles.logo} onClick={redirectToDashboard} />
        <div className={styles.title} onClick={redirectToDashboard}>
          Слушай Прабхупаду
        </div>
      </div>
      <div className={styles.btnContainer}>
        <div className={styles.menuIconWrapper}>
          <MenuIcon onClick={showDrawer} />
        </div>
        {/*{*/}
        {/*  menuConfig.map(menu => {*/}
        {/*    console.log('debug-menu', menu);*/}
        {/*    const isBtn = menu.type === BTN_TYPE.BUTTON;*/}
        {/*    return <Link*/}
        {/*      to={menu.url}*/}
        {/*      // className={isBtn ? styles.btn : styles.link}*/}
        {/*    >{menu.title}</Link>*/}
        {/*  })*/}
        {/*}*/}
      </div>
    </div>
  );
}

const useStyles = makeStyles<Theme>((theme) => ({
  headerContainer: {
    display: 'flex',
    flex: 1,
    height: 105,
    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.05)',
    flexDirection: 'row',
    color: '#603004',

    [deviceMaxWidth.size500]: {
      height: 150,
      boxShadow: 'none',
    },
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // justifyContent: 'center',
    width: '45%',
    margin: '25px 0px 25px 70px',

    [deviceMaxWidth.size500]: {
      flex: 1,
      flexDirection: 'column',
    },
  },
  logo: {
    cursor: 'pointer',
    [deviceMaxWidth.size500]: {
      width: 41,
      height: 41,
    },
  },
  menuIconWrapper: {
    [deviceMaxWidth.size500]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      marginTop: -18,
      cursor: 'pointer',
    },
    [deviceMinWidth.size501]: {
      display: 'none',
    },
  },
  title: {
    cursor: 'pointer',
    fontSize: 20,
    marginLeft: 14,
    fontFamily: 'Inter',
    fontWeight: 400,

    [deviceMaxWidth.size500]: {
      marginLeft: 0,
      marginTop: 10,
      fontSize: 18,
    },
  },

  btnContainer: {
    margin: '25px',
  },

  link: {},

  btn: {},
}));
